.container {
  border: 1px solid;
  box-sizing: border-box;
  border-radius: var(--dds-border-radius-surface);
}

.container--info {
  border-color: var(--dds-color-border-info);
  background-color: var(--dds-color-surface-info-default);
}
.container--warning {
  border-color: var(--dds-color-border-warning);
  background-color: var(--dds-color-surface-warning-default);
}
.container--danger {
  border-color: var(--dds-color-border-danger);
  background-color: var(--dds-color-surface-danger-default);
}
.container--success {
  border-color: var(--dds-color-border-success);
  background-color: var(--dds-color-surface-success-default);
}

.container--tips {
  border-color: var(--dds-color-border-info);
  background-color: var(--dds-color-surface-info-default);
}
